//src/core/api/endpoints.ts
export const ENDPOINTS = {
    SEND_CONTACT_FORM: "/contact-form",
    GET_PRODUCTS: "/products",
    CHECKOUT_CART: "/checkout",
};
export const BASE_API_URL = "https://623rv9idyg.execute-api.us-east-1.amazonaws.com/PROD";
